<div class="sap-flag-item">
    <div class="flag-name">
        <ng-container *ngIf="parent !== null">
            <span class="parent-flag">{{parent + ' > '}}</span>
        </ng-container>
        <span class="sap-flag">{{flag}}</span>
    </div>

    <div class="flag-value-string" *ngIf="type === 'string'">
        <span>{{data}}</span>
    </div>

    <div class="flag-value-list" *ngIf="type === 'list'">
        <ng-container *ngFor="let string of data; let last = last">
            <span *ngIf="!last">{{string + ', '}}</span>
            <span *ngIf="last">{{string}}</span>
        </ng-container>
    </div>

    <div class="flag-value-boolean" *ngIf="type === 'boolean'" [class.active]="data">
        <input type="checkbox" [name]="flag" [checked]="data">
        <span class="slider"></span>
    </div>
</div>
